import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { eventsSearchSelectors } from '@ucheba/store/events/search'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { EActivityTypes } from '@ucheba/utils/types/userActivityTypes'
import EventsList from '../../../../../../../components/EventsList/desktop/EventsList'
import { useUserActivity } from '../../../../../../../../utils/hooks/useUserActivity'
import { EActivityInfoPart } from '../../../../../../../components/InstitutionExams/types'

const Events: FC = () => {
  const openDays = useSelector(eventsSearchSelectors.entity)
  const { asPath, push, query } = useRouter()
  const { id: institutionId } = query
  const { setUserActivity } = useUserActivity()

  const handleShowAllClick = async (): Promise<void> => {
    await setUserActivity({
      activityType: EActivityTypes.infoPartViewed,
      institutionId: Array.isArray(institutionId)
        ? Number(institutionId[0])
        : Number(institutionId),
      data: { infoPart: EActivityInfoPart.questions },
    })
  }

  if (!openDays?.items.length) return null

  const items =
    Array.isArray(openDays?.items) && openDays?.items.length > 2
      ? [...openDays.items]?.splice(0, 2)
      : openDays?.items

  return (
    <>
      <Heading h2='Дни открытых дверей' spacing='small' />

      <Spacing spacing='large' />

      <EventsList href='/for-abiturients/events' items={items} />

      {openDays?.total > 2 && (
        <>
          <Spacing spacing='xlarge' />
          <Button
            block
            color='blue'
            view='outline'
            onClick={() => {
              handleShowAllClick()

              push(`/${asPath}/events`)
            }}
          >
            Показать все мероприятия
          </Button>
        </>
      )}

      <Spacing spacing='uxlarge' />
    </>
  )
}

export default Events
